<!--&================== TITLE ALL TASK ==================&-->
<div class="title-components">
  <h1>Tareas pendientes HOE</h1>
</div>

<!--&================= CONTENT-TASKS =================&-->

<div class="Container-AllTasks container-global-components">


  <!---================= CONTAINER TABLE ALL TASK =================--->
  <div class="Table-container-Task-Global">

    <p-table #dt [value]="List_All_Task" [(selection)]="SelectedList_All_Task" dataKey="id" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Name','NameUser']">

      <!--&================= SEARCH AND ALL TASK =================&-->
      <ng-template pTemplate="caption">
        <div class="SectionCreateTotal Section-Task">
          <div class="left-CT">
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Task_Filter" type="text"
              (input)="dt.filterGlobal(Task_Filter, 'contains')" placeholder="Buscar tarea" />
            </div>
          </div>
          <div class="right-CT">
            <div class="AllFiles">Total de Tareas: <b>{{List_All_Task.length}}</b> <i
                class="fa-solid fa-list-check"></i>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">

        <tr>

          <ng-container *ngFor="let Header of HeadersTask">

            <ng-container *ngIf="Header.Key_Header==='NAT'">
              <th pSortableColumn="Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='INV'">
              <th pSortableColumn="Invoice_4M" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Invoice_4M"></p-sortIcon>
                    <p-columnFilter type="text" field="Invoice_4M" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAA'">
              <th pSortableColumn="Date_Start" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Start"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Start" display="menu" class="ml-auto"></p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USA'">
              <th pSortableColumn="NameUser" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="NameUser"></p-sortIcon>
                    <p-columnFilter field="NameUser" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DES'">
              <th pSortableColumn="Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

          </ng-container>

          <th class="ContTask">Revisar</th>

        </tr>

      </ng-template>

      <ng-template pTemplate="body" let-List_All_Task>

        <tr>
          <td *ngFor="let Header of HeadersTask">

            <ng-container *ngIf="Header.Key_Header==='NAT'">
              {{List_All_Task.Name}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='INV'">
              {{List_All_Task.Invoice_4M}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAA'">
              {{DateTaskCreate(List_All_Task.Date_Start)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USA'">
              {{List_All_Task.NameUser}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DES'">
              Se le ha asignado la tarea de revisión del documento: {{List_All_Task.Name}}
            </ng-container>

          </td>
          <td class="CheckTask">
            <a [routerLink]="['/Dashboard/CCP/CheckTaskAss/',List_All_Task.ID]" class="Btn-Task Btn-text-task">
              <span class="text">Ver tarea</span>
            </a>
          </td>
        </tr>

      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="List_All_Task.length>0" colspan="8">Sin coincidencias.</td>
        </tr>
        <tr>
          <td class="Not-Task" colspan="20">
            <!-- &================= NOT TASK =================& -->
            <div class="Not-Task" *ngIf="List_All_Task.length===0 && LoadPage">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Not-Task.png" alt="">
              </div>
              <div class="Text-Not-Task">
                ¡{{GetGreeting()}}, {{NameUser()}}, no tienes tareas por revisar!
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </div>


</div>

<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
